import React from 'react';

const ThankYou = () => {
  return (
    <div style={{ textAlign: 'center', padding: '50px', paddingTop: '100px'}}>
      <h1 style={{ fontSize: '3rem', fontWeight: 'bold', color: '#4CAF50' }}>Thank You!</h1>
      <p style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#333' }}>
        Your form has been successfully submitted.
      </p>
    </div>
  );
};

export default ThankYou;
